import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { NavBar } from '@/components/NavBar/NavBar'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import NavigationChips from '@/components/NavigationChips/NavigationChips'
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css'
import Splash from '@/components/splash/Splash'
import { useSnapshot } from 'valtio'
import store from '@/store'
import { AlertContainer } from '@/components/UiElements/Alert'
import OnboardingProvider from '@/features/onboarding/OnboardingProvider'
import { saveLastVisitedPage } from '@/utils/lastVisitedPage'
import { isExplicitlyLoggedOut } from '@/utils/authSession'

export default function App() {
  const snap = useSnapshot(store)
  const { pathname, search, hash } = useLocation()
  const isPublicRoute = pathname?.startsWith('/public') || pathname?.startsWith('/_auth')

  const userEmail = snap.currentUser?.email
  const selectedCompanyId = snap.currentUser?.selectedCompany?.id
  const selectedStoreName = snap.currentUser?.selectedCompany?.store_name

  useEffect(() => {
    saveLastVisitedPage(userEmail, selectedCompanyId, selectedStoreName, `${pathname}${search}${hash}`)
  }, [userEmail, selectedCompanyId, selectedStoreName, pathname, search, hash])

  if (!import.meta.env.VITE_AUTH_DOMAIN || !import.meta.env.VITE_AUTH_CLIENT_ID) {
    return null
  }

  if (isPublicRoute) {
    return <Outlet />
  }

  if (isExplicitlyLoggedOut()) {
    return <Navigate to="/_auth/login" replace />
  }

  return (
    <>
      <AlertContainer />
      <ToastContainer
        toastClassName={'!rounded-lg !border-[0px] !border-white !text-gray-800'}
        progressClassName={'pointer-events-none !z-0 !h-[100%] !w-[100%] !opacity-10'}
      />

      <NavBar />
      <div className="flex flex-grow min-h-[calc(100%-75px)]">
        {snap.currentUser && snap.currentUser.selectedCompany && (
          <OnboardingProvider>
            <NavigationChips />
            <div className="w-[100%] flex flex-col flex-grow relative min-h-full">
              <Outlet />
            </div>
          </OnboardingProvider>
        )}
      </div>
      {snap?.loadingPage && <Splash text={snap.loadingPage} className={`${snap?.loadingPageClassNames || ''}`} />}
      {!snap.currentUser?.isAuthenticated && (
        <Splash className={`!opacity-100 !bg-opacity-[1] ${!snap.currentUser ? 'invert' : ''}`} />
      )}
    </>
  )
}
